//librerias
import { Component, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
//componentes
import { ModalCourseCardComponent } from "../modal-course-card/modal-course-card.component";
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";

@Component({
  selector: "app-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.css"],
})
export class CardComponent {
  @Input() courseSession?: ICourseSession;

  constructor(private modalService: NgbModal) {}

  openModal() {
    const modalRef = this.modalService.open(ModalCourseCardComponent, {
      size: "lg",
      centered: true,
      backdrop: "static",
    });
    // Puedes pasar datos al modal si es necesario
    modalRef.componentInstance.data = this.courseSession;
  }
}
